import { render, staticRenderFns } from "./DialogTermosUso.vue?vue&type=template&id=47e66eb7&"
import script from "./DialogTermosUso.vue?vue&type=script&lang=js&"
export * from "./DialogTermosUso.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports